import { render, staticRenderFns } from "./nf-cascader.vue?vue&type=template&id=31b73520"
import script from "./nf-cascader.vue?vue&type=script&lang=js"
export * from "./nf-cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports